import React from 'react';

import { Tag, Flex, Space } from 'antd';

interface ITagsProps {
    label: string | undefined;
    vertical?: boolean;
}
const Tags = (props: ITagsProps) => {
    const { label, vertical } = props;

    if (!label) return;

    let tags: Array<string> = [];
    try {
        tags = JSON.parse(label);
    } catch {
        tags.push(label);
    }

    return (
        <Flex gap='small' vertical={vertical} wrap>
            {tags.map((tag: string) => {
                return (
                    <Tag key={tag} variant='solid' color='var(--primary-color)' style={{ color: '#000000', width: 'fit-content' }}>
                        #{tag}
                    </Tag>
                );
            })}
        </Flex>
    );
};

export default Tags;
